import { BuiltInFieldsService } from '@services/built-in-fields.service';
import { SortProcessor } from './sort-processor';
import { CustomCodingFieldsManager } from './custom-coding-fields-manager';
import { MultiSort, Sort } from '@dialogs/select-sort/select-sort.component';
import { ProductionJobView } from '@models/ui/production-job-view.model';
import { MultiSortView, SortView } from '@models/ui/multi-sort-view.model';
import { BuiltInFieldId } from '@models/built-in-field-id.enum';

export class ProductionSortProcessor extends SortProcessor {
    constructor(
        public builtInFieldService: BuiltInFieldsService,
        public ccFieldManager: CustomCodingFieldsManager
    ) {
        super(builtInFieldService, ccFieldManager);
    }

    public generateMultiSortView(multiSort: MultiSort): MultiSortView {
        let firstDisplayName = this.generateProductionDetailsDisplayString(multiSort.first);
        if (multiSort.first.fieldId === BuiltInFieldId.MasterDate)
            firstDisplayName = `${firstDisplayName} (Default)`;
        const first: SortView = new SortView(
            multiSort.first.fieldId,
            multiSort.first.direction,
            firstDisplayName
        );
        const second: SortView = new SortView(
            multiSort.second.fieldId,
            multiSort.second.direction,
            this.generateProductionDetailsDisplayString(multiSort.second)
        );
        const third: SortView = new SortView(
            multiSort.third.fieldId,
            multiSort.third.direction,
            this.generateProductionDetailsDisplayString(multiSort.third)
        );
        return new MultiSortView(first, second, third);
    }

    public createMultiSortFromLegacySort(productionJob: ProductionJobView): MultiSortView {
        let sortData: MultiSort;
        if (productionJob.level1FieldId === '00000000-0000-0000-0000-000000000000') {
            const sortField1: Sort = this.sortMap.get(productionJob.sortLevel1);
            const sortField2: Sort = productionJob.sortLevel2 !== 0 ? this.sortMap.get(productionJob.sortLevel2) : {
                fieldId: '',
                direction: 'ASC'
            };
            sortData = {
                first: sortField1,
                second: sortField2,
                third: {
                    fieldId: '',
                    direction: 'ASC'
                }
            };
        }
        else {

            const customField: Sort = { fieldId: productionJob.level1FieldId, direction: 'ASC' };
            sortData = {
                first: customField,
                second: {
                    fieldId: '',
                    direction: 'ASC'
                },
                third: {
                    fieldId: '',
                    direction: 'ASC'
                }
            };
        }
        return this.generateMultiSortView(sortData);
    }

    private generateProductionDetailsDisplayString(sort: Sort): string {
        if (sort.fieldId)
            return this.getDisplayTitleById(sort.fieldId);
        else
            return 'No Id';
    }

    private sortMap: Map<number, Sort> = new Map([
        [0, { fieldId: BuiltInFieldId.DocTitle, direction: 'ASC' }],
        [1, { fieldId: BuiltInFieldId.SourceFilePath, direction: 'ASC' }], 
        [2, { fieldId: BuiltInFieldId.MasterDate, direction: 'ASC' }],
        [3, { fieldId: BuiltInFieldId.Custodian, direction: 'ASC' }], 
    ]);
}
